(() => {
  const tagName = 'hbn-recognition-tabs';

  if (customElements.get(tagName)) return;

  class HbnRecognitionTabs extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();

      this.dataset.hbnReady = 'true';
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activate(index, false), { signal: this.controller.signal });
        tab.addEventListener('keydown', (event) => this.handleKeydown(event, index), { signal: this.controller.signal });
      });
      const preload = () => this.querySelectorAll('img').forEach(img => { img.loading = 'eager'; });
      if ('IntersectionObserver' in window) {
        this.preloadObserver = new IntersectionObserver(entries => {
          if (entries[0].isIntersecting) { preload(); this.preloadObserver.disconnect(); }
        }, { rootMargin: '350px' });
        this.preloadObserver.observe(this);
      } else preload();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.preloadObserver?.disconnect();
      delete this.dataset.hbnReady;
    }

    activate(index, moveFocus) {
      if (!this.tabs.length || !this.panels.length) return;

      const activeIndex = (index + this.tabs.length) % this.tabs.length;

      this.tabs.forEach((tab, tabIndex) => {
        const isActive = tabIndex === activeIndex;
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
      });

      this.panels.forEach((panel, panelIndex) => {
        const isActive = panelIndex === activeIndex;
        panel.classList.toggle('is-active', isActive);
        panel.setAttribute('aria-hidden', String(!isActive));
        panel.tabIndex = isActive ? 0 : -1;
      });

      if (moveFocus) this.tabs[activeIndex].focus();
    }

    handleKeydown(event, currentIndex) {
      let nextIndex = currentIndex;

      switch (event.key) {
        case 'ArrowRight':
          nextIndex = currentIndex + 1;
          break;
        case 'ArrowLeft':
          nextIndex = currentIndex - 1;
          break;
        case 'Home':
          nextIndex = 0;
          break;
        case 'End':
          nextIndex = this.tabs.length - 1;
          break;
        default:
          return;
      }

      event.preventDefault();
      this.activate(nextIndex, true);
    }
  }

  customElements.define(tagName, HbnRecognitionTabs);
})();